export function getBaseRoot() {

    if(this.$rootUrl){
        //console.log("dev getBaseRoot A", this.$rootUrl)
        return this.$rootUrl
    }else{
        if(process.env.VUE_APP_ROOT_URL) {
            return process.env.VUE_APP_ROOT_URL;
        }else{
            return this.getApiConfig('root');
        }
    }



}

export function getRequestHeader() {
    return  {
        "X-fifth-cms-user" : localStorage.getItem(this.getConfig('login_local_storage_name'))
    }
}

export function getRequestHeaderUpload() {
    return  {
        'Content-Type': 'multipart/form-data',
        "X-fifth-cms-user" : localStorage.getItem(this.getConfig('login_local_storage_name'))
    }
}

export function calculateTimeDifference(locale, from, to) {
    // Vytvoříme Date objekty z řetězců
    const output = {
        "date": null,
        "time": null,
        "range": null,
    }

    const start = new Date(from.replace(' ', 'T'));
    const end = new Date(to.replace(' ', 'T'));

    const diffInMilliseconds = end.getTime() - start.getTime();
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

    const intervalValue = {
        days: null,
        hours: null,
        minutes: null,
    }


    if(diffInMinutes < 60) {
        intervalValue.minutes = diffInMinutes;
    }else if(diffInMinutes < 24* 60) {
        intervalValue.hours = Math.floor(diffInMinutes/(60));
        const minutes = diffInMinutes - (intervalValue.hours * 60);
        if(minutes) intervalValue.minutes = minutes;

    }else{
        intervalValue.days = Math.floor(diffInMinutes/(24*60));
        const minutesToHour = diffInMinutes - (intervalValue.days * 24 * 60);
        intervalValue.hours = Math.floor(minutesToHour/(60));
        const minutes = diffInMinutes - (intervalValue.days * 24 * 60) - (intervalValue.hours * 60);
        if(minutes) intervalValue.minutes = minutes;
    }

    output.range = intervalValue

    const localeX = navigator.language || 'cs-CZ'; // Použije jazyk prohlížeče, nebo jako zálohu češtinu

    // Možnosti formátování
    const options = {
        year: 'numeric',
        month: 'long', // nebo 'short', 'numeric', '2-digit'
        day: 'numeric', // nebo '2-digit'
        hour: '2-digit', // nebo 'numeric'
        minute: '2-digit', // nebo 'numeric'
        // second: '2-digit', // pokud chcete i sekundy
    };

    const formattedStartDate = start.toLocaleString(localeX, options);
    const formattedEndDate = end.toLocaleString(localeX, options);

    const startYear = start.getFullYear();
    const startMonth = start.getMonth();
    const startDay = start.getDay();
    const endYear = end.getFullYear();
    const endMonth = end.getMonth();
    const endDay = end.getDay();

    if(
        startYear == endYear
        && startMonth == endMonth
        && startDay == endDay
    ){
        const dateFormatter = new Intl.DateTimeFormat(locale, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
        const timeFormatter = new Intl.DateTimeFormat(locale, {
            hour: 'numeric',
            minute: 'numeric',
        });
        output.time = timeFormatter.format(start)
        output.date = dateFormatter.format(start)
    } else if(
        startYear == endYear
        && startMonth == endMonth
    ) {
        const endDateFormatter = new Intl.DateTimeFormat(locale, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
        const startlDateFormatter = new Intl.DateTimeFormat(locale, {
            day: 'numeric',
        });

        output.date = `${startlDateFormatter.format(start)} - ${endDateFormatter.format(end)}`

    } else if(
        startYear == endYear
    ) {
        const fullDateFormatter = new Intl.DateTimeFormat(locale, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
        output.date = `${fullDateFormatter.format(start)} - ${fullDateFormatter.format(end)}`

    }

    return output;
}